import React, { useCallback } from 'react';
import { Button, Row, Col } from 'reactstrap';

import {
  AudioPlayer, Intl, ModalForm,
} from 'components';

export default ( {
  uri, modalTitle, open, download, translateTitle = false, onClose, values,
} ) => {
  const downloadAudio = useCallback( () => {

  }, [] );
  return (
    <ModalForm
      title={modalTitle}
      translateTitle={translateTitle}
      size="md"
      open={open}
      values={values}
      showErrorsInHeader
      onClose={onClose}
      onSubmit={downloadAudio}
      footer={(
        <Button
          color="app-default"
          size="app-sm"
          className="font-weight-700"
          onClick={onClose}
        >
          <Intl id="okBtn" />
        </Button>
      )}
    >
      <Row className="my-5">
        <Col md={10} className="m-auto">
          <AudioPlayer
            src={uri}
          />
          {!!download
          && (
            <a
              href={uri}
              target="_blank"
              rel="noopener noreferrer"
              className="btn-app-default btn-app-sm btn-block font-weight-700 mt-3 text-center"
            >
              <Intl id="download" />
            </a>
          )}
        </Col>
      </Row>
    </ModalForm>
  );
};
